import { GetAccountBalancesRequest, GetAccountsRequest } from './api.types';

export const CEX_ACCOUNT_QUERY_KEYS = {
  all: ['cex-account'] as const,
  accounts: (req: GetAccountsRequest) => [...CEX_ACCOUNT_QUERY_KEYS.all, 'accounts', req] as const,
  list: (req: GetAccountBalancesRequest) => [...CEX_ACCOUNT_QUERY_KEYS.all, 'list', req] as const,
  balanceSync: (req: { account_id: number; cex: unknown; symbol: string }) =>
    [...CEX_ACCOUNT_QUERY_KEYS.all, 'balance-sync', req] as const,
  feeSync: (req: { account_id: number }) =>
    [...CEX_ACCOUNT_QUERY_KEYS.all, 'fee-sync', req] as const,
} as const;

export const CEX_ACCOUNT_AUTO_REFRESH_KEYS = {
  accounts: (pairId: number) => `cex-account/accounts/auto-refresh/${pairId}` as const,
} as const;
